/*
 * PETYNA — deux corrections par rapport a la version d'origine du theme :
 *
 * 1. Le pied de page ne porte pas l'attribut data-ref="footer". this.footer valait
 *    donc null, et le test de visibilite levait une TypeError (offsetTop sur null)
 *    des que le formulaire sortait du champ. On ajoute un repli sur la balise footer.
 *
 * 2. Le test isElementInViewport du theme s'appuie sur offsetTop, qui est mesure
 *    par rapport au parent positionne et non au document. Sur cette fiche produit il
 *    concluait toujours que le formulaire etait visible, donc la barre ne s'activait
 *    jamais. On le remplace par getBoundingClientRect, qui donne la position reelle
 *    a l'ecran. Le remplacement est limite a ce fichier : l'utilitaire partage du
 *    theme n'est pas modifie.
 */

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
    this.onScroll = () => this.displayStickyAddToCart();
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer =
      document.querySelector('[data-ref="footer"]') ||
      document.querySelector('footer') ||
      document.querySelector('.shopify-section-group-footer-group');

    this.displayStickyAddToCart();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  isVisible(element) {
    if (!element) return false;

    const rect = element.getBoundingClientRect();

    if (rect.width === 0 && rect.height === 0) return false;

    return rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight);
  }

  displayStickyAddToCart() {
    if (this.isVisible(this.form) || this.isVisible(this.footer)) {
      this.dataset.active = 'false';
      this.classList.remove('color-scheme-1');
    } else {
      this.dataset.active = 'true';
      this.classList.add('color-scheme-1');
    }
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
